import React from 'react';

// Decorative leaf sprig used in the corners of the "One Email Can Help Build…"
// section (preventive-health pages, EN + CN). Inline SVG so it can be tinted
// via currentColor and doesn't add an HTTP request. Rendered aria-hidden.

function LeafSprig({ className = '', flip = false, tilt = 0, hang = false }) {
  // - `flip`: mirror horizontally so the right-corner sprig fans the other way
  // - `tilt`: small rotation so the sprig leans outward from its corner
  // - `hang`: 180° rotation so the sprig hangs *down* from a top-corner
  //   anchor (default is upright, growing up from a bottom-corner anchor)
  const transform = [
    hang ? 'rotate(180deg)' : '',
    flip ? 'scaleX(-1)' : '',
    tilt ? `rotate(${tilt}deg)` : '',
  ].filter(Boolean).join(' ');
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 120 160"
      className={className}
      style={transform ? { transform, transformOrigin: 'center' } : undefined}
      fill="currentColor"
    >
      {/* central stem */}
      <path
        d="M60 158 C 58 120, 62 90, 60 40"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.55"
      />
      {/* paired leaves — offset up the stem */}
      <g opacity="0.9">
        <path d="M60 132 C 46 128, 30 118, 22 100 C 40 106, 54 116, 60 132 Z" />
        <path d="M60 132 C 74 128, 90 118, 98 100 C 80 106, 66 116, 60 132 Z" />
      </g>
      <g opacity="0.85">
        <path d="M60 104 C 48 100, 34 90, 28 74 C 44 80, 55 90, 60 104 Z" />
        <path d="M60 104 C 72 100, 86 90, 92 74 C 76 80, 65 90, 60 104 Z" />
      </g>
      <g opacity="0.8">
        <path d="M60 78 C 50 74, 40 66, 36 54 C 48 58, 56 66, 60 78 Z" />
        <path d="M60 78 C 70 74, 80 66, 84 54 C 72 58, 64 66, 60 78 Z" />
      </g>
      <g opacity="0.75">
        <path d="M60 54 C 53 50, 46 44, 44 34 C 52 38, 57 44, 60 54 Z" />
        <path d="M60 54 C 67 50, 74 44, 76 34 C 68 38, 63 44, 60 54 Z" />
      </g>
    </svg>
  );
}

// Renders two sprigs — one anchored to the bottom-left, one to the bottom-right
// of the parent (which must be `relative`). Sized to look natural at mobile and
// desktop; caller can override color via the `text-*` class in `tone`.
export default function LeafDecor({ tone = 'text-brand-300/60' }) {
  const sizing = 'w-28 sm:w-40';
  return (
    <>
      {/* Bottom-left — stem base at bottom-left corner, fanning up and right. */}
      <LeafSprig
        tilt={-18}
        className={`pointer-events-none absolute -left-3 -bottom-3 ${sizing} ${tone}`}
      />
      {/* Bottom-right — mirrored, fanning up and left. */}
      <LeafSprig
        flip
        tilt={18}
        className={`pointer-events-none absolute -right-3 -bottom-3 ${sizing} ${tone}`}
      />
    </>
  );
}
